import * as React from 'react'
import './index.css'

interface Props {
  imageUrl?: string
  message?: string
}

export default class RedeemToast extends React.Component<Props, object> {
  constructor (props: Props) {
    super(props)
  }

  renderContainer = () => {
    const { imageUrl, message } = this.props
    return (
      <view className="toast-mask">
        <view
          className="toast-container"
          onClick={() => {
            // do noting 防止点击内容区域弹窗消失
          }}
        >
          <view className="toast-content">
            {imageUrl ? <image className="toast-image" src={imageUrl} /> : null}
            {message ? <text className="toast-message" content={message} /> : null}
          </view>
        </view>
      </view>
    )
  }

  render () {
    return <modal>{this.renderContainer()}</modal>
  }
}
